export const calculateRemainingMinutesAndSeconds = (countDown: number): number[] => {
	const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
	return [minutes < 0 ? 0 : minutes, seconds < 0 ? 0 : seconds];
};

export const getTargetAccountIdSuffix = (targetAccountId: string | undefined | null): string => {
	return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
};
